import React from "react";
export const HomeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 18V15"
        stroke="#92A5B5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.07 2.81985L3.14002 8.36985C2.36002 8.98985 1.86002 10.2998 2.03002 11.2798L3.36002 19.2398C3.60002 20.6598 4.96002 21.8098 6.40002 21.8098H17.6C19.03 21.8098 20.4 20.6498 20.64 19.2398L21.97 11.2798C22.13 10.2998 21.63 8.98985 20.86 8.36985L13.93 2.82985C12.86 1.96985 11.13 1.96985 10.07 2.81985Z"
        stroke="#92A5B5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HomeColorIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.54271 1.15016L8.54309 1.14985C9.62734 0.279042 11.3675 0.284136 12.468 1.16073C12.4681 1.16084 12.4683 1.16094 12.4684 1.16105L19.0141 6.39756C19.0146 6.39802 19.0152 6.39849 19.0158 6.39895C19.393 6.70711 19.7197 7.18942 19.9304 7.74099C20.1411 8.29218 20.2196 8.86987 20.1463 9.35096L18.8874 16.8845C18.8873 16.885 18.8872 16.8855 18.8871 16.8859C18.6375 18.3188 17.2432 19.5 15.8 19.5H5.2C3.73553 19.5 2.37253 18.3476 2.12297 16.8965C2.12291 16.8961 2.12285 16.8958 2.1228 16.8955L0.863162 9.35761L0.862968 9.35646C0.780822 8.8718 0.854552 8.29296 1.06468 7.74192C1.27479 7.19094 1.60552 6.70909 1.99184 6.40086L1.99271 6.40016L8.54271 1.15016ZM10.5 17.25C11.1861 17.25 11.75 16.6862 11.75 16V13C11.75 12.3139 11.1861 11.75 10.5 11.75C9.81386 11.75 9.25 12.3139 9.25 13V16C9.25 16.6862 9.81386 17.25 10.5 17.25Z"
        fill="#459173"
        stroke="#459173"
      />
    </svg>
  );
};
export const MessageIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 19H8C4 19 2 18 2 13V8C2 4 4 2 8 2H16C20 2 22 4 22 8V13C22 17 20 19 16 19H15.5C15.19 19 14.89 19.15 14.7 19.4L13.2 21.4C12.54 22.28 11.46 22.28 10.8 21.4L9.3 19.4C9.14 19.18 8.77 19 8.5 19Z"
        stroke="#92A5B5"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9965 11H16.0054"
        stroke="#92A5B5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9955 11H12.0045"
        stroke="#92A5B5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99451 11H8.00349"
        stroke="#92A5B5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MessageColorIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1993 19.039L10.1993 19.039L10.1956 19.0343C10.0528 18.8494 9.85354 18.7065 9.66111 18.6103C9.46956 18.5145 9.23469 18.44 9 18.44H7.5C5.01418 18.44 3 16.4319 3 13.96V12.96V6.98C3 4.5081 5.01418 2.5 7.5 2.5H17.5C19.9858 2.5 22 4.5081 22 6.98V13.96C22 16.4319 19.9858 18.44 17.5 18.44H16C15.5314 18.44 15.085 18.6649 14.8019 19.0375L14.8007 19.039L13.3007 21.029L13.3 21.03C13.0506 21.3626 12.7559 21.49 12.5 21.49C12.2441 21.49 11.9494 21.3626 11.7 21.03L11.6993 21.029L10.1993 19.039ZM7 11C7 11.8229 7.6606 12.5 8.5 12.5C9.3394 12.5 10 11.8229 10 11C10 10.1739 9.32614 9.5 8.5 9.5C7.67386 9.5 7 10.1739 7 11ZM11 11C11 11.8229 11.6606 12.5 12.5 12.5C13.3394 12.5 14 11.8229 14 11C14 10.1739 13.3261 9.5 12.5 9.5C11.6739 9.5 11 10.1739 11 11ZM15 11C15 11.8229 15.6606 12.5 16.5 12.5C17.3394 12.5 18 11.8229 18 11C18 10.1739 17.3261 9.5 16.5 9.5C15.6739 9.5 15 10.1739 15 11Z"
        fill="#459173"
        stroke="#459173"
      />
    </svg>
  );
};
export const NewsfeedIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 16.7399V4.66994C22 3.46994 21.02 2.57994 19.83 2.67994H19.77C17.67 2.85994 14.48 3.92994 12.7 5.04994L12.53 5.15994C12.24 5.33994 11.76 5.33994 11.47 5.15994L11.22 5.00994C9.44 3.89994 6.26 2.83994 4.16 2.66994C2.97 2.56994 2 3.46994 2 4.65994V16.7399C2 17.6999 2.78 18.5999 3.74 18.7199L4.03 18.7599C6.2 19.0499 9.55 20.1499 11.47 21.1999L11.51 21.2199C11.78 21.3699 12.21 21.3699 12.47 21.2199C14.39 20.1599 17.75 19.0499 19.93 18.7599L20.26 18.7199C21.22 18.5999 22 17.6999 22 16.7399Z"
        stroke="#92A5B5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 5.48999V20.49"
        stroke="#92A5B5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.75 8.48999H5.5"
        stroke="#92A5B5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 11.49H5.5"
        stroke="#92A5B5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NewsfeedColoricon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.6786 18.2237L20.6786 18.2237L20.676 18.224L20.366 18.264L20.3635 18.2644C18.6692 18.4917 16.3162 19.1865 14.4274 19.9785C14.116 20.1072 13.75 19.873 13.75 19.5099V5.59993C13.75 5.42221 13.8517 5.24613 14.0288 5.14923C15.8004 4.19101 18.4898 3.33806 20.2916 3.17993H20.33C21.2539 3.17993 22 3.92607 22 4.84993V16.7399C22 17.4552 21.4004 18.1344 20.6786 18.2237Z"
        fill="#459173"
        stroke="#459173"
      />
      <path
        d="M4.31138 18.2237L4.31398 18.224L4.62398 18.264L4.62647 18.2644C6.32081 18.4917 8.67371 19.1865 10.5625 19.9785M4.31138 18.2237L4.72999 3.17993H4.70843M4.31138 18.2237C3.5896 18.1344 2.98999 17.4552 2.98999 16.7399V4.84993C2.98999 3.92607 3.73613 3.17993 4.65999 3.17993H4.70843M4.31138 18.2237L4.70843 3.17993M10.5625 19.9785C10.5628 19.9786 10.5631 19.9787 10.5634 19.9788L10.37 20.4398L10.5618 19.9782C10.562 19.9783 10.5623 19.9784 10.5625 19.9785ZM10.5625 19.9785C10.874 20.1073 11.24 19.873 11.24 19.5099V5.59993C11.24 5.40583 11.1425 5.24295 10.9712 5.14921M10.9712 5.14921C10.9715 5.14938 10.9718 5.14954 10.9721 5.1497L11.21 4.70994L10.9706 5.14888C10.9708 5.14899 10.971 5.1491 10.9712 5.14921ZM10.9712 5.14921C9.19955 4.191 6.51015 3.33806 4.70843 3.17993M7.74999 7.23993H5.49999C4.81385 7.23993 4.24999 7.80379 4.24999 8.48993C4.24999 9.19041 4.8182 9.73993 5.49999 9.73993H7.74999C8.43178 9.73993 8.99999 9.19041 8.99999 8.48993C8.99999 7.80379 8.43613 7.23993 7.74999 7.23993ZM5.49999 12.7399H8.49999C9.18178 12.7399 9.74999 12.1904 9.74999 11.4899C9.74999 10.8038 9.18613 10.2399 8.49999 10.2399H5.49999C4.81385 10.2399 4.24999 10.8038 4.24999 11.4899C4.24999 12.1904 4.8182 12.7399 5.49999 12.7399Z"
        fill="#459173"
        stroke="#459173"
      />
    </svg>
  );
};

export const NotificationIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.02 2.91003C8.71 2.91003 6.02 5.60003 6.02 8.91003V11.8C6.02 12.41 5.76 13.34 5.45 13.86L4.3 15.77C3.59 16.95 4.08 18.26 5.38 18.7C9.69 20.14 14.34 20.14 18.65 18.7C19.86 18.3 20.39 16.87 19.73 15.77L18.58 13.86C18.28 13.34 18.02 12.41 18.02 11.8V8.91003C18.02 5.61003 15.32 2.91003 12.02 2.91003Z"
        stroke="#92A5B5"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M13.87 3.19994C13.56 3.10994 13.24 3.03994 12.91 2.99994C11.95 2.87994 11.03 2.94994 10.17 3.19994C10.46 2.45994 11.18 1.93994 12.02 1.93994C12.86 1.93994 13.58 2.45994 13.87 3.19994Z"
        stroke="#92A5B5"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.02 19.0601C15.02 20.7101 13.67 22.0601 12.02 22.0601C11.2 22.0601 10.44 21.7201 9.89999 21.1801C9.35999 20.6401 9.01999 19.8801 9.01999 19.0601"
        stroke="#92A5B5"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export function Google() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 48 48"
    >
      <path
        fill="#ffc107"
        d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4C12.955 4 4 12.955 4 24s8.955 20 20 20s20-8.955 20-20c0-1.341-.138-2.65-.389-3.917"
      ></path>
      <path
        fill="#ff3d00"
        d="m6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4C16.318 4 9.656 8.337 6.306 14.691"
      ></path>
      <path
        fill="#4caf50"
        d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.9 11.9 0 0 1 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44"
      ></path>
      <path
        fill="#1976d2"
        d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 0 1-4.087 5.571l.003-.002l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917"
      ></path>
    </svg>
  );
}

export function Apple() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 128 128"
    >
      <path d="M97.905 67.885c.174 18.8 16.494 25.057 16.674 25.137c-.138.44-2.607 8.916-8.597 17.669c-5.178 7.568-10.553 15.108-19.018 15.266c-8.318.152-10.993-4.934-20.504-4.934c-9.508 0-12.479 4.776-20.354 5.086c-8.172.31-14.395-8.185-19.616-15.724C15.822 94.961 7.669 66.8 18.616 47.791c5.438-9.44 15.158-15.417 25.707-15.571c8.024-.153 15.598 5.398 20.503 5.398c4.902 0 14.106-6.676 23.782-5.696c4.051.169 15.421 1.636 22.722 12.324c-.587.365-13.566 7.921-13.425 23.639M82.272 21.719c4.338-5.251 7.258-12.563 6.462-19.836c-6.254.251-13.816 4.167-18.301 9.416c-4.02 4.647-7.54 12.087-6.591 19.216c6.971.54 14.091-3.542 18.43-8.796"></path>
    </svg>
  );
}

export function LoadingSpinner() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={48}
      height={48}
      viewBox="0 0 24 24"
    >
      <g fill="#459173">
        <circle cx={12} cy={3.5} r={1.5}>
          <animateTransform
            attributeName="transform"
            calcMode="discrete"
            dur="2.4s"
            repeatCount="indefinite"
            type="rotate"
            values="0 12 12;90 12 12;180 12 12;270 12 12"
          ></animateTransform>
          <animate
            attributeName="opacity"
            dur="0.6s"
            repeatCount="indefinite"
            values="1;1;0"
          ></animate>
        </circle>
        <circle cx={12} cy={3.5} r={1.5} transform="rotate(30 12 12)">
          <animateTransform
            attributeName="transform"
            begin="0.2s"
            calcMode="discrete"
            dur="2.4s"
            repeatCount="indefinite"
            type="rotate"
            values="30 12 12;120 12 12;210 12 12;300 12 12"
          ></animateTransform>
          <animate
            attributeName="opacity"
            begin="0.2s"
            dur="0.6s"
            repeatCount="indefinite"
            values="1;1;0"
          ></animate>
        </circle>
        <circle cx={12} cy={3.5} r={1.5} transform="rotate(60 12 12)">
          <animateTransform
            attributeName="transform"
            begin="0.4s"
            calcMode="discrete"
            dur="2.4s"
            repeatCount="indefinite"
            type="rotate"
            values="60 12 12;150 12 12;240 12 12;330 12 12"
          ></animateTransform>
          <animate
            attributeName="opacity"
            begin="0.4s"
            dur="0.6s"
            repeatCount="indefinite"
            values="1;1;0"
          ></animate>
        </circle>
      </g>
    </svg>
  );
}
export function LoadingWhiteSpinner() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={48}
      height={48}
      viewBox="0 0 24 24"
    >
      <g fill="#fff">
        <circle cx={12} cy={3.5} r={1.5}>
          <animateTransform
            attributeName="transform"
            calcMode="discrete"
            dur="2.4s"
            repeatCount="indefinite"
            type="rotate"
            values="0 12 12;90 12 12;180 12 12;270 12 12"
          ></animateTransform>
          <animate
            attributeName="opacity"
            dur="0.6s"
            repeatCount="indefinite"
            values="1;1;0"
          ></animate>
        </circle>
        <circle cx={12} cy={3.5} r={1.5} transform="rotate(30 12 12)">
          <animateTransform
            attributeName="transform"
            begin="0.2s"
            calcMode="discrete"
            dur="2.4s"
            repeatCount="indefinite"
            type="rotate"
            values="30 12 12;120 12 12;210 12 12;300 12 12"
          ></animateTransform>
          <animate
            attributeName="opacity"
            begin="0.2s"
            dur="0.6s"
            repeatCount="indefinite"
            values="1;1;0"
          ></animate>
        </circle>
        <circle cx={12} cy={3.5} r={1.5} transform="rotate(60 12 12)">
          <animateTransform
            attributeName="transform"
            begin="0.4s"
            calcMode="discrete"
            dur="2.4s"
            repeatCount="indefinite"
            type="rotate"
            values="60 12 12;150 12 12;240 12 12;330 12 12"
          ></animateTransform>
          <animate
            attributeName="opacity"
            begin="0.4s"
            dur="0.6s"
            repeatCount="indefinite"
            values="1;1;0"
          ></animate>
        </circle>
      </g>
    </svg>
  );
}

export function CalendarIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={28}
      height={28}
      viewBox="0 0 24 24"
    >
      <g fill="none">
        <path
          stroke="black"
          strokeWidth={1.5}
          d="M2 12c0-3.771 0-5.657 1.172-6.828S6.229 4 10 4h4c3.771 0 5.657 0 6.828 1.172S22 8.229 22 12v2c0 3.771 0 5.657-1.172 6.828S17.771 22 14 22h-4c-3.771 0-5.657 0-6.828-1.172S2 17.771 2 14z"
        ></path>
        <path
          stroke="black"
          strokeLinecap="round"
          strokeWidth={1.5}
          d="M7 4V2.5M17 4V2.5M2.5 9h19"
        ></path>
        <path
          fill="black"
          d="M18 17a1 1 0 1 1-2 0a1 1 0 0 1 2 0m0-4a1 1 0 1 1-2 0a1 1 0 0 1 2 0m-5 4a1 1 0 1 1-2 0a1 1 0 0 1 2 0m0-4a1 1 0 1 1-2 0a1 1 0 0 1 2 0m-5 4a1 1 0 1 1-2 0a1 1 0 0 1 2 0m0-4a1 1 0 1 1-2 0a1 1 0 0 1 2 0"
        ></path>
      </g>
    </svg>
  );
}

export function NotificationSmallIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 512 512"
    >
      <path
        fill="white"
        d="M440.08 341.31c-1.66-2-3.29-4-4.89-5.93c-22-26.61-35.31-42.67-35.31-118c0-39-9.33-71-27.72-95c-13.56-17.73-31.89-31.18-56.05-41.12a3 3 0 0 1-.82-.67C306.6 51.49 282.82 32 256 32s-50.59 19.49-59.28 48.56a3.1 3.1 0 0 1-.81.65c-56.38 23.21-83.78 67.74-83.78 136.14c0 75.36-13.29 91.42-35.31 118c-1.6 1.93-3.23 3.89-4.89 5.93a35.16 35.16 0 0 0-4.65 37.62c6.17 13 19.32 21.07 34.33 21.07H410.5c14.94 0 28-8.06 34.19-21a35.17 35.17 0 0 0-4.61-37.66M256 480a80.06 80.06 0 0 0 70.44-42.13a4 4 0 0 0-3.54-5.87H189.12a4 4 0 0 0-3.55 5.87A80.06 80.06 0 0 0 256 480"
      ></path>
    </svg>
  );
}

export function EditIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 24 24"
    >
      <path
        fill="white"
        d="M18.925 3.137a3.027 3.027 0 0 0-4.283.001l-9.507 9.52a3.03 3.03 0 0 0-.885 2.139V18c0 .414.336.75.75.75h3.223c.803 0 1.573-.32 2.14-.887l9.5-9.506a3.03 3.03 0 0 0 0-4.28zM4 20.25a.75.75 0 0 0 0 1.5h16a.75.75 0 0 0 0-1.5z"
      ></path>
    </svg>
  );
}

export function BackArrowIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 15 15"
    >
      <path
        fill="black"
        fillRule="evenodd"
        d="m2.707 8l3.147 3.146l-.708.707L.793 7.5l4.353-4.354l.708.708L2.707 7H14v1z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export function CrownIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
    >
      <path
        fill="#459173"
        d="M5 16L3 5l5.5 5L12 4l3.5 6L21 5l-2 11zm14 3c0 .6-.4 1-1 1H6c-.6 0-1-.4-1-1v-1h14z"
      ></path>
    </svg>
  );
}

export function ArrowRight() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
    >
      <path
        fill="#459173"
        d="M4 12h12.25L11 6.75l.66-.75l6.5 6.5l-6.5 6.5l-.66-.75L16.25 13H4z"
      ></path>
    </svg>
  );
}

export function UploadIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22px"
      height="22px"
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4m14-7l-5-5l-5 5m5-5v12"
      ></path>
    </svg>
  );
}

export function HandsFistIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 256 256"
    >
      <path
        fill="#FFFFFF"
        d="M232 120v8a104 104 0 0 1-104.37 104c-54-.19-98-42.06-103.12-94.78a4 4 0 0 1 5.56-4A35.94 35.94 0 0 0 72 122.59a35.92 35.92 0 0 0 53.94 2.33a40.36 40.36 0 0 0 12.87 13A47.94 47.94 0 0 0 120 176a8 8 0 0 0 8.67 8a8.21 8.21 0 0 0 7.33-8.26A32 32 0 0 1 168 144a8 8 0 0 0 8-8.53a8.18 8.18 0 0 0-8.25-7.47H160a24 24 0 0 1-24-24V88h64a32 32 0 0 1 32 32m-187.27 0C55.57 119.6 64 110.37 64 99.52v-23C64 65.63 55.57 56.4 44.73 56A20 20 0 0 0 24 76v24a20 20 0 0 0 20.73 20m56 0c10.84-.39 19.27-9.62 19.27-20.47v-47c0-10.85-8.43-20.08-19.27-20.47A20 20 0 0 0 80 52v48a20 20 0 0 0 20.73 20M176 52a20 20 0 0 0-20.73-20c-10.84.4-19.27 9.63-19.27 20.48V72h36a4 4 0 0 0 4-4Z"
      ></path>
    </svg>
  );
}

export function MessageDotIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
    >
      <path
        fill="#459173"
        d="M20.605 4.17a4.67 4.67 0 0 0-3.33-1.38H6.705a4.71 4.71 0 0 0-4.71 4.72v6.6a4.71 4.71 0 0 0 4.71 4.72h2.33l1.95 1.94c.127.143.284.255.46.33c.175.072.361.11.55.11q.286-.004.55-.11a1.6 1.6 0 0 0 .44-.31l2-2h2.33a4.7 4.7 0 0 0 3.33-1.38a4.8 4.8 0 0 0 1-1.53c.234-.575.357-1.19.36-1.81v-6.6a4.67 4.67 0 0 0-1.4-3.3m-13.24 8.17a1.66 1.66 0 1 1 1.66-1.66a1.67 1.67 0 0 1-1.66 1.66m4.63 0a1.66 1.66 0 1 1 0-3.32a1.66 1.66 0 0 1 0 3.32m4.62 0a1.66 1.66 0 1 1 1.66-1.66a1.67 1.67 0 0 1-1.66 1.66"
      ></path>
    </svg>
  );
}

export function ArrowRigntLine() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12px"
      height="24px"
      viewBox="0 0 12 24"
    >
      <defs>
        <path
          id="weuiArrowOutlined0"
          fill="#4A5E6D"
          d="m7.588 12.43l-1.061 1.06L.748 7.713a.996.996 0 0 1 0-1.413L6.527.52l1.06 1.06l-5.424 5.425z"
        ></path>
      </defs>
      <use
        fillRule="evenodd"
        href="#weuiArrowOutlined0"
        transform="rotate(-180 5.02 9.505)"
      ></use>
    </svg>
  );
}

export function CloseDrawerIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
    >
      <path
        fill="rgba(128, 128, 132, 1)"
        d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2s10 4.477 10 10"
        opacity={0.5}
      ></path>
      <path
        fill="rgba(128, 128, 132, 1)"
        d="M8.97 8.97a.75.75 0 0 1 1.06 0L12 10.94l1.97-1.97a.75.75 0 1 1 1.06 1.06L13.06 12l1.97 1.97a.75.75 0 0 1-1.06 1.06L12 13.06l-1.97 1.97a.75.75 0 0 1-1.06-1.06L10.94 12l-1.97-1.97a.75.75 0 0 1 0-1.06"
      ></path>
    </svg>
  );
}

export function RequiredIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="0.6em"
      height="0.6em"
      viewBox="0 0 24 24"
    >
      <path
        fill="red"
        d="M21 13h-6.6l4.7 4.7l-1.4 1.4l-4.7-4.7V21h-2v-6.7L6.3 19l-1.4-1.4L9.4 13H3v-2h6.6L4.9 6.3l1.4-1.4L11 9.6V3h2v6.4l4.6-4.6L19 6.3L14.3 11H21z"
      ></path>
    </svg>
  );
}

export function DotsVerticalIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.4em"
      height="1.4em"
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        stroke="#4A5E6D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M12 5.92A.96.96 0 1 0 12 4a.96.96 0 0 0 0 1.92m0 7.04a.96.96 0 1 0 0-1.92a.96.96 0 0 0 0 1.92M12 20a.96.96 0 1 0 0-1.92a.96.96 0 0 0 0 1.92"
      ></path>
    </svg>
  );
}

export function FlagOutlineIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={30}
      height={30}
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        stroke="#459173"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 3v2m0 16v-8m0-8h12l-2 4l2 4H8m0-8v8"
      ></path>
    </svg>
  );
}

export function FlagContainedIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={30}
      height={30}
      viewBox="0 0 24 24"
    >
      <path
        fill="#459173"
        fillRule="evenodd"
        d="M20 14a1 1 0 0 0 .894-1.447L19.118 9l1.776-3.553A1 1 0 0 0 20 4H9V3a1 1 0 1 0-2 0v18a1 1 0 1 0 2 0v-7z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
